import React from 'react';
import PropTypes from 'prop-types';

const Fineprint = ({ text, type, children }) => (
	<div className="common-ui-fineprint">
		<i className={type} aria-label={type} />
		<span className="text">{children || text}</span>
	</div>
);

Fineprint.propTypes = {
	text: PropTypes.string,
	type: PropTypes.oneOf([
		'affirm',
		'error',
		'featured',
		'help',
		'information',
		'sparkle',
		'warning',
	]),
	children: PropTypes.node,
};

export default Fineprint;
